import React, { Component } from 'react';
import { Modal, Button, Tag, message } from 'antd';
import FormList from '../../basicElement/FormList';
import Fetch from "../../../common/Fetch";
import API_URL from '../../../common/url';

class SetDirector extends Component {
    state = {
        visible: false,
        loading: false,
        data: {},
        list: [],
    }

    loadData = () => {
        const { data: { areaId } } = this.state;
        this.setState({ loading: true });
        Fetch.post(API_URL.teaching.queryByAreaId, {
            areaId,
        }).then(res => {
            const { data: list } = res;
            this.setState({
                list,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    show = (record) => {
        this.setState({
            list: [],
            visible: true,
            data: {...(record || {})},
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = (option, key, type) => {
        const { data } = this.state;
        const { text, value } = option;
        data.userId = value;
        data.userName = text;
        this.setState({ data });
    }

    getColumns = () => {
        const { loading, data } = this.state;

        // 字段属性配置
        const columns = [{
            name: '区域',
            key: 'areaName',
            type: 'text',
        }, {
            name: '带教主管',
            key: 'userName',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyWord',
                style: { width: 200 },
                placeholder: '输入姓名/工号检索',
                params: { limit: 20, roleCodes: 'CRCC,CRCM' },
                url: API_URL.teaching.queryEmpListByRoleCode,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' },
            },
            rules: {
                required: true,
            },
            suffix: <Button type="primary" loading={loading} style={{marginLeft: 40}} onClick={this.confirm}>添加</Button>,
        }];

        // 字段值、显示状态配置
        const traverseColumns = function (columns) {
            columns.forEach(column => {
                const { key, type, children, rules = {} } = column;
                if (children) {
                    traverseColumns(children);
                } else {
                    const typeProperty = column.typeProperty || (column.typeProperty = {});
                    typeProperty.canEdit = true;
                    typeProperty.value = data[key];
                }
            });
        }
        traverseColumns(columns);

        return columns;
    }

    handleDelete = (teachSupervisorId) => {
        const { list } = this.state;
        if (list.length === 1) {
            message.warning('该区域下仅剩一位带教主管，不能删除！');
            return;
        }
        this.setState({ loading: true });
        Fetch.post(API_URL.teaching.delTeachSupervisor, {
            teachSupervisorId
        }).then(res => {
            const { success } = res;
            message.success(success);
            this.setState({
                loading: false,
            }, () => {
                this.loadData();
                this.props.loadData();
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    getDataList = () => {
        const { list } = this.state;
        return (
            (list || []).map((item, index) =>
                <Tag key={item.teachSupervisorId} className="close-color" closable color="#DDD" style={{color: 'rgba(0, 0, 0, .65)'}} onClose={() => this.handleDelete(item.teachSupervisorId)}>{item.supervisorName}[{item.employeeCode}]</Tag> 
            )
        );
    }

    confirm = () => {
        const hasWritten = this.formRef.validate();
        if (!hasWritten) return;

        const { data } = this.state;
        const { userId, areaId } = data;
        this.setState({ loading: true });
        Fetch.post(API_URL.teaching.saveTeachSupervisor, {
            userId,
            areaId,
        }).then(res => {
            const { success } = res;
            message.success(success);
            this.setState({
                loading: false,
            }, () => {
                this.handleChange({}, 'userName', 'searchRetrieve');
                this.loadData();
                this.props.loadData();
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    render() {
        const { visible } = this.state;
        return (
            <Modal
                title="设置带教主管"
                visible={visible}
                onCancel={this.hide}
                className="create-modal"
                maskClosable={false}
                width="500px"
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <FormList
                    className="form-list"
                    columns={this.getColumns()}
                    onChange={this.handleChange}
                    ref={el => this.formRef = el}
                />
                <div
                    className="modal-content"
                    style={{ padding: '10px 0 0', borderTop: '1px solid #d1d1d1' }}
                >
                    <ul className="modal-list" style={{position: 'relative'}}>
                        <li className="modal-item" style={{ padingLeft: 30 }}>
                            <div className="item-left" style={{width: 126, paddingRight: 10}}>已添区域带教主管:</div>
                            <div className="item-right">
                                { this.getDataList() }
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

export { SetDirector };


// WEBPACK FOOTER //
// ./src/components/teachingManagement/director/Widget.js